"use client";

import React from "react";
import NotFound from "./(marketing)/_components/pages/NotFoundPage";

export default function NotFoundPage() {
  return <NotFound />;
}
